import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const MAX_ENTITY_ADMINS = 2;

/**
 * Entity-admins assignment modal state + handlers.
 * Each entity may have at most 2 admin users; we toggle a local selection
 * before persisting via PUT /admin/entities/{id}/admins.
 */
export function useAdminEntityAdmins({ token, refetchEntities }) {
  const [showEntityAdminsModal, setShowEntityAdminsModal] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [entityAdminSearch, setEntityAdminSearch] = useState('');
  const [selectedEntityAdmins, setSelectedEntityAdmins] = useState([]);

  const openEntityAdminsModal = (entity) => {
    setSelectedEntity(entity);
    setSelectedEntityAdmins(entity.entity_admins || []);
    setEntityAdminSearch('');
    setShowEntityAdminsModal(true);
  };

  const toggleEntityAdmin = (userId) => {
    setSelectedEntityAdmins((prev) => {
      if (prev.includes(userId)) {
        return prev.filter((id) => id !== userId);
      }
      if (prev.length >= MAX_ENTITY_ADMINS) {
        toast.error(`Maximum ${MAX_ENTITY_ADMINS} entity admins allowed`);
        return prev;
      }
      return [...prev, userId];
    });
  };

  const handleAssignEntityAdmins = async () => {
    try {
      await axios.put(
        `${API}/admin/entities/${selectedEntity.entity_id}/admins`,
        selectedEntityAdmins,
        {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        }
      );
      toast.success('Entity admins updated successfully');
      setShowEntityAdminsModal(false);
      refetchEntities?.();
    } catch (error) {
      console.error('Error assigning entity admins:', error);
      toast.error(error.response?.data?.detail || 'Failed to assign entity admins');
    }
  };

  return {
    showEntityAdminsModal,
    setShowEntityAdminsModal,
    selectedEntity,
    entityAdminSearch,
    setEntityAdminSearch,
    selectedEntityAdmins,
    openEntityAdminsModal,
    toggleEntityAdmin,
    handleAssignEntityAdmins,
  };
}
